import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CoursePaymentType } from "../../../types/Finance";

const initialState: CoursePaymentType = {
  description: "",
  status: false,
  isToDebtsGenerateAutomatically: false
};

const coursePaymentSlice = createSlice({
  name: "coursePayment",
  initialState,
  reducers: {
    setCoursePaymentData: (state, action: PayloadAction<CoursePaymentType>) => ({
      ...state,
      ...action.payload,
    }),
    resetCoursePaymentData: () => ({ ...initialState }),
  },
});

export const { setCoursePaymentData, resetCoursePaymentData } = coursePaymentSlice.actions;
export default coursePaymentSlice.reducer;
